import moment from 'moment-timezone';
import uuidTime from 'uuid-time';
import activityService from 'services/ActivityService';
import pathwayService from 'services/PathwayService';

export const getAllLessons = async (activityId) => {
  let item = await activityService.getActivity(activityId);

  const coursePathwayObjects = await Promise.all(item.childrenPathways.map(async (pathwayId) => {
    const pathwayObj = await pathwayService.getPathway(pathwayId);

    return pathwayObj;
  }));

  // Map through coursePathwayObjects
  const allChapters = [];
  coursePathwayObjects.forEach( (coursePathwayObject) => {
    if (coursePathwayObject.children) {
      coursePathwayObject.children.forEach( (activity) => {
        allChapters.push(activity);
      });
    }
  });

  const chapterObjects = await Promise.all(allChapters.map(async (activityPointer) => {
    const activityObj = await activityService.getActivity(activityPointer.elementId);
    return activityObj;
  }));

  const lessonPathways = await Promise.all(chapterObjects.map(async (chapter) => {
    const { pathwayId } = chapter.config.lessons;

    const lessonPathwayObj = await pathwayService.getPathway(pathwayId);
    return lessonPathwayObj;
  }));
  try {
    const lessonObjects = await Promise.all(lessonPathways.map(async (lessonPathwayObj) => {
      if (lessonPathwayObj.children) {
        const lessonObj = await Promise.all(lessonPathwayObj.children.map(async (lesson) => {
          const item = await activityService.getActivity(lesson.elementId);
          return {
            activityId: item.activityId,
            title: item.config.title,
          };
        }));
        return lessonObj;
      }     
  
    }));
    return  lessonObjects.filter((lessonObj) => lessonObj!== undefined).flat(2);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);    
  } 
};

var localtz = moment.tz.guess();

export const getFormatTime = (date, format) => moment(new Date(date)).tz(localtz).format(format);

/**
 * Get elapsed time based on format
 * -UUID
 * -Date
 * @param {string} timeStamp
 */
export const getTime = (timeStamp, format) => {
  let time = null;
  // FIXME: fix with regex
  try {
    time = getFormatTime(uuidTime.v1(timeStamp), format);
  } catch (error) {
    time = getFormatTime(timeStamp, format);
  }
  return time;
};

export const isPostPublicationStatusFeatureDate = (timeStamp) => (
  //Cut off date Mon Nov 15 2021 00:00:00 GMT-0800 (Pacific Standard Time)
  (uuidTime.v1(timeStamp)) > (1636963200 * 1000) ? true : false
);

/**
 * @description Remove HTML tags from string
 * @param {string} textWithHTMLTag
 */
export const stripTags = (textWithHTMLTag) => {
  const cleanText = textWithHTMLTag?.replace(/(<([^>]+)>)/ig, '');
  return cleanText ?? '';
};

export const sortByDate = (list) => {
  try {
    return list.sort((a, b) => uuidTime.v1(b.updatedAt) - uuidTime.v1(a.updatedAt));
  } catch (e) {
    return list;
  }
};

/**
 * @desc download excel reports from s3 locations
 * @param {string} endPoint
 * @param {string} fileName
 * @param {string} format
 */
export const download = async (endPoint, fileName, format, afterDownloadCallBack) => {
  if(!fileName){
    fileName = "Preflight error report";
  }
  fetch(endPoint, {
    method: 'GET',
  })
    .then((response) => response.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.${format}`);
      // Append to html link element page
      document.body.appendChild(link);
      // Start download
      link.click();
      // Clean up and remove the link
      link.parentNode.removeChild(link);
      // Releases the existing objectURL
      window.URL.revokeObjectURL(url);
    });
  afterDownloadCallBack();
};

/**
 * @description decoding HTML entities
 * HTML entities are a set of character codes used to represent characters reserved by HTML. It starts with ampersand & and ends with a semicolon ;
 * @param {string} str
 */
export const decodeHTMLEntity = (str) => {
  if (!str) return;
  const textarea = document.createElement("textarea");
  textarea.innerHTML = str;
  return textarea.value;
};
